import { useEffect, useState } from 'react';

import { isSecondDecemberEvent } from '../_utils/isSecondDecemberEvent';

interface UseInviteEventPeriodValueOptions<T> {
  ssrFallbackValue?: T;
}

type UseInviteEventPeriodValue = {
  <T>(
    beforeChangeValue: T,
    afterChangeValue: T,
    options: { ssrFallbackValue: T },
  ): T;
  <T>(
    beforeChangeValue: T,
    afterChangeValue: T,
    options?: UseInviteEventPeriodValueOptions<T>,
  ): T | undefined;
};

export const useInviteEventPeriodValue: UseInviteEventPeriodValue = <T>(
  beforeChangeValue: T,
  afterChangeValue: T,
  options: UseInviteEventPeriodValueOptions<T> = {},
) => {
  const { ssrFallbackValue } = options;
  const [value, setValue] = useState<T | undefined>(ssrFallbackValue);

  useEffect(() => {
    // SSR에서 기간이 확정되지 않도록, 실제 분기 로직은 hydration 이후에만 실행
    // eslint-disable-next-line react-hooks/set-state-in-effect -- 현재 시각 기반 분기라 SSR/CSR 불일치 방지를 위한 hydration 게이트
    setValue(isSecondDecemberEvent() ? afterChangeValue : beforeChangeValue);
  }, [afterChangeValue, beforeChangeValue]);

  return value;
};
